import React, { useState, Fragment } from "react"

import FuwModal from "./FuwModal"

const FileUploaderWrapper = (props) => {
  const {
    children,
    accountId,
    imageCategory,
    className,
    aspectRatio,
    maxNumberOfUploads = 1,
    enableCrop = true,
    onUploadComplete = () => { },
    options = { device: true, link: true, media: true, camera: true },
  } = props

  const [openModal, setOpenModal] = useState(false)

  return (
    <Fragment>
      <div
        className={className}
        onClick={() => setOpenModal(true)}
      >
        {children}
      </div>

      <FuwModal
        options={options}
        accountId={accountId}
        imageCategory={imageCategory}
        enableCrop={enableCrop}
        aspectRatio={aspectRatio}
        openModal={openModal}
        setOpenModal={setOpenModal}
        onUploadComplete={onUploadComplete}
        maxNumberOfUploads={maxNumberOfUploads}
      />
    </Fragment>
  )
}

export default FileUploaderWrapper